var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoCourseImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 1200,
  height: 760,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 1200,
  height: 760,
  fill: "#F7F4F2",
  rx: 56
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 1112,
  height: 672,
  x: 44,
  y: 44,
  fill: "#FCFAF8",
  rx: 40
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 164,
  height: 20,
  x: 120,
  y: 118,
  fill: "#EEE8E5",
  rx: 10
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 448,
  height: 18,
  x: 120,
  y: 170,
  fill: "#E8E1DE",
  rx: 9
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 356,
  height: 18,
  x: 120,
  y: 208,
  fill: "#F0EBE8",
  rx: 9
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 960,
  height: 252,
  x: 120,
  y: 286,
  fill: "#F5F0ED",
  rx: 28
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 196,
  height: 52,
  x: 120,
  y: 576,
  fill: "#F0EBE8",
  rx: 26
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 128,
  height: 52,
  x: 340,
  y: 576,
  fill: "#F4EFEC",
  rx: 26
})));
export { SvgNoCourseImage as ReactComponent };
export default __webpack_public_path__ + "4f844560b0bfa267f6555cf787767b04.svg";